import { SegnalazioneForm } from "@/features/segnalazioni";

export default function SegnalazionePage() {
  return <SegnalazioneForm />;
}
